import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import CompaniesList from './CompaniesList';

//redux

const Companies = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Empresa', icon: 'icon-building-2' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Empresa' links={breadcrumbLinks} icon={'icon-building'} />
					<CompaniesList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Companies;
